import { OptionWithIdType } from '~/features/types';
import { getData } from '~/utils/service';
import {
  SUB_SPECIALTY_CERT_BY_PARENT_ROUTE_NAME,
  SUB_SPECIALTY_CERT_ROUTE_NAME,
} from './constants';

export const SUB_SPECIALTY_CERT_API_CALLS = {
  getByCertification: async (props: {
    specialtyCertificationId: string;
    transformResponse?: (data: string) => OptionWithIdType[];
  }): Promise<OptionWithIdType[]> => {
    return await getData(SUB_SPECIALTY_CERT_BY_PARENT_ROUTE_NAME, {
      pathParams: { specialtyCertificationId: props.specialtyCertificationId },
      transformResponse: props.transformResponse,
    });
  },
  get: async (props: {
    specialtyBoardId: string;
    transformResponse?: (data: string) => OptionWithIdType[];
  }): Promise<OptionWithIdType[]> => {
    return await getData(SUB_SPECIALTY_CERT_ROUTE_NAME, {
      pathParams: { specialtyBoardId: props.specialtyBoardId },
      transformResponse: props.transformResponse,
    });
  },
};
